import { PlusIcon, EyeIcon, ArrowUpTrayIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import Card, { CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Badge from '@/components/ui/Badge';
import {
  TableContainer, Table, TableHead, TableBody, TableRow, TableHeaderCell, TableCell,
} from '@/components/ui/Table';

const mockFeeds = [
  { id: 1, name: 'Main ONIX Feed', book_count: 243, created_at: '2024-01-15', published_at: '2024-01-15', status: 'published' },
  { id: 2, name: 'Apple Books Feed', book_count: 142, created_at: '2024-01-14', published_at: '2024-01-14', status: 'published' },
  { id: 3, name: 'New Releases Q1', book_count: 28, created_at: '2024-01-10', published_at: null, status: 'draft' },
];

export default function DistFeedsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">ONIX Feeds</h1>
          <p className="text-slate-500 mt-1">Manage and publish ONIX metadata feeds</p>
        </div>
        <Button leftIcon={<PlusIcon className="w-4 h-4" />}>Create Feed</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-slate-800">{mockFeeds.length}</p>
          <p className="text-sm text-slate-500">Total Feeds</p>
        </CardBody></Card>
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-success-500">{mockFeeds.filter(f => f.status === 'published').length}</p>
          <p className="text-sm text-slate-500">Published</p>
        </CardBody></Card>
        <Card><CardBody className="text-center">
          <p className="text-3xl font-bold text-warning-500">{mockFeeds.filter(f => f.status === 'draft').length}</p>
          <p className="text-sm text-slate-500">Drafts</p>
        </CardBody></Card>
      </div>

      <Card padding="none">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow isHoverable={false}>
                <TableHeaderCell>Feed Name</TableHeaderCell>
                <TableHeaderCell>Books</TableHeaderCell>
                <TableHeaderCell>Created</TableHeaderCell>
                <TableHeaderCell>Published</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Actions</TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mockFeeds.map((feed) => (
                <TableRow key={feed.id}>
                  <TableCell className="font-medium">{feed.name}</TableCell>
                  <TableCell>{feed.book_count}</TableCell>
                  <TableCell>{feed.created_at}</TableCell>
                  <TableCell>{feed.published_at || '--'}</TableCell>
                  <TableCell>
                    <Badge variant={feed.status === 'published' ? 'success' : 'warning'}>{feed.status}</Badge>
                  </TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      <Button variant="ghost" size="sm" leftIcon={<EyeIcon className="w-3 h-3" />}>Preview</Button>
                      <Button variant="ghost" size="sm" leftIcon={<CheckCircleIcon className="w-3 h-3" />}>Validate</Button>
                      <Button variant="ghost" size="sm" leftIcon={<ArrowUpTrayIcon className="w-3 h-3" />}>Publish</Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </div>
  );
}

